import { render, staticRenderFns } from "./TiltakFilerGroup.vue?vue&type=template&id=40faab12"
import script from "./TiltakFilerGroup.vue?vue&type=script&lang=js"
export * from "./TiltakFilerGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports